import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';
import _ from 'lodash';
import config from '../../config';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationWeeklyTableV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            height:props.height,
            maxHeight:props.maxHeight,
            loading:true,
            theHead:[]
            
      };
    }

    roundPercent(value){
        let thisGuy=value*100;
        thisGuy=Math.round(thisGuy * 10) / 10;
        return thisGuy;
    }

    formatDate(date){
        let d = date;
        let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
        let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
        let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
        return mo+" "+da+", "+ye;
    }

    async loadOut(){
        // const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let qWhere="1=1";
        let url=config.apiv2.registrationWeekly;
        let thisIsTheHead=[];
        let thisIsTheBody=[];

        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","dateWeek");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            //build head
            thisIsTheHead.push(<th key="theHeader">Week</th>);
            for (const [key,value] of Object.entries(qData.features[0].attributes)){
                if(key!=="OBJECTID" && key!=="dateWeek"){
                    console.log(key);
                    thisIsTheHead.push(<th key={key}>{key}</th>);
                }
                
            }
            for (const [key,value] of Object.entries(qData.features)){
                // console.log(value.attributes);
                let d = new Date(value.attributes.dateWeek); // The 0 there is the key, which sets the date to the epoch
                thisIsTheBody.push(<tr key={Math.floor(Math.random()*10100)}><td key={Math.floor(Math.random()*10100)}>{this.formatDate(d)}</td><td key={Math.floor(Math.random()*10100)}>{this.roundPercent(value.attributes.Asian)+"%"}</td><td key={Math.floor(Math.random()*10100)}>{this.roundPercent(value.attributes.Black)+"%"}</td><td key={Math.floor(Math.random()*10100)}>{this.roundPercent(value.attributes.Hispanic)+"%"}</td><td key={Math.floor(Math.random()*10100)}>{this.roundPercent(value.attributes.White)+"%"}</td><td key={Math.floor(Math.random()*10100)}>{this.roundPercent(value.attributes.Other)+"%"}</td></tr>)
            }

            this.setState({
                loading:false,
                theHead:thisIsTheHead,
                theBody:thisIsTheBody,
                error:false,
            });
            
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }


    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <>
                    <Table striped bordered hover size="sm" responsive style={{fontSize:"10pt",height:this.state.height}}>
                        <thead>
                            <tr>
                            {/* style={{backgroundColor:"#b63a3a",color:"#FFFFFF"}} */}
                                {this.state.theHead}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.theBody}
                        </tbody>
                    </Table>
                </>
            );
        }
    }
}

export default RegistrationWeeklyTableV2;